/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonMinutelyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateValidator(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/validator/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateValidatorStaker(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/validator/staker/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateNativeTokenTotalSupply(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/total/supply',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTotalBondedToken(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/total/bonded',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinPrice2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/token/price/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateStakingAprCalcValue(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/staking/apr/calc/value',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProposal(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/proposal',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProposalVotingPeriodVoteTally(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/proposal/voting/period/vote/tally',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProposalVoteVoteType(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/proposal/vote/voter/type',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProposalValidatorDidNotVote(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/proposal/validator/did/not/vote',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateGovernanceMetadata(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/governance/metadata',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setFinalityProvider(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/finality/provider',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBtcStakingTransaction(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/btc/staking',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateActualStakingApr(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/minutely/actual/staking/apr',
        });
    }

}
